$(document).ready(function () {
	$('[data-toggle=prd-image]').click(function () {
		let $container = $('.image-block');
		let $thumbs = $container.find('.thumbs a');
		let $original = $container.find('.original');
		let src = $(this).data('original');
		let key = $(this).data('key');
		
		$container.find('.active').removeClass('active');
		$(this).addClass('active');
		
		$original.find('img').fadeOut();
		
		$original.find('a').attr('href', src).data('key', key);
		$original.find('img').attr('src', src).fadeIn();
		
		return false;
	});
	
	$('[data-toggle=prd-image-full]').click(function () {
		let $container = $('.image-block');
		let $thumbs = $container.find('.thumbs').find('[data-original]');
		let thumbs = [];
		let key = $(this).data('key');
		
		if ($thumbs.length) {
			$.merge($thumbs.slice(key), $thumbs.slice(0, key)).each(function () {
				let $_self = $(this),
					src = $_self.data('original');
				
				thumbs.push({
					src: src
				});
			});
		} else {
			thumbs.push({
				src: $(this).attr('href')
			});
		}
		
		$.fancybox.open(thumbs, {
			loop: true,
			buttons: [
				"zoom",
				//"share",
				"slideShow",
				"fullScreen",
				//"download",
				//"thumbs",
				"close"
			],
			
			thumbs: {
				autoStart: true
			},
			
			lang: "ru",
			i18n: {
				ru: {
					CLOSE: "Закрыть",
					NEXT: "Следующий",
					PREV: "Предыдущий",
					ERROR: "Запрашиваемый контент не удалось загрузить. <br/> Попробуйте позже.",
					PLAY_START: "Запустить слайдшоу",
					PLAY_STOP: "Остановить слайдшоу",
					FULL_SCREEN: "Навесь экран",
					THUMBS: "Миниатюры",
					DOWNLOAD: "Скачать",
					SHARE: "Поделиться",
					ZOOM: "Увеличить"
				}
			}
		});
		
		return false;
	});
});